import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './theme.css'

/**
 * Entry point. `basename="/console"` matches Vite's `base`, so client-side routes resolve under the path
 * Spring serves the bundle from and a deep link like /console/reliability survives a refresh.
 */
createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter basename="/console">
      <App />
    </BrowserRouter>
  </StrictMode>,
)
